import { USER_LOGOUT_ROUTE } from '@r1-frontend/shared/constants/routes';

export const changeCity = (
    nextProviderId: number,
    referrer: string,
    withLogout = false,
): void => {
    const isAbsoluteUrl = referrer.startsWith('http');
    if (isAbsoluteUrl) {
        return window.location.replace(referrer);
    }

    const url = new URL(referrer, window.location.origin);

    const updatedOrigin = url.origin.replace(/^.*?\./, '');

    const searchParams = new URLSearchParams(window.location.search);
    [...searchParams.entries()].forEach(([name, value]) => {
        if (name !== 'referrer') {
            url.searchParams.append(name, value);
        }
    });

    url.searchParams.append('nextProviderId', `${nextProviderId}`);

    if (withLogout) {
        if (!url.searchParams.has('referrer')) {
            url.searchParams.append('referrer', url.pathname);
        }

        url.pathname = USER_LOGOUT_ROUTE;
    }

    const newUrl = `${url.protocol}//${updatedOrigin}${url.pathname}?${url.searchParams.toString()}`;

    return window.location.replace(newUrl);
};
